<template lang="pug">
.fieldset(
  :class="classes"
)
  slot
</template>

<script>
export default {
  name: 'fieldset-section',
  props: {
    flex: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        '--flex': this.flex,
        '--large': this.large,
      }
    },
  },
}
</script>

<style lang="sass">
/* see App.vue for these root styles:
  --label-fontsize: calc(1rem * .8)
  --input-fontsize: 1rem
  --input-lineheight: 1.25
  --input-border-color: #afafaf
  --input-padding-v: .25rem
  --input-padding-h: .75rem */

.fieldset
  &.--large
    --input-fontsize: 1.25rem
    --input-lineheight: 1.4
    --label-fontsize: calc(1.25rem * .8)
  
  ::placeholder
    color: var(--placeholder-color)

.fieldset
  position: relative
  margin-bottom: 1rem
  font-size: var(--input-fontsize)
  line-height: var(--input-lineheight)

  &.--flex
    display: flex
    flex-direction: column
  
    .fieldset__input + .fieldset__label
      order: -1
      height: calc(var(--label-fontsize) + var(--input-padding-v) * 2)

    .fieldset__input.--empty + .fieldset__label
      span
        position: absolute
        transform: translate(var(--input-padding-h), calc(var(--label-fontsize) + (var(--input-padding-v) * 2)))
        transition: transform 0.3s, font-size 0.3s, color 0.3s
        font-size: var(--input-fontsize)
        color: var(--placeholder-color)
        font-weight: inherit
    
    .fieldset__input:not(.--empty) + .fieldset__label,
    .fieldset__input:focus + .fieldset__label 
      span
        transform: translate(0, 0)
        font-size: inherit
        font-weight: normal
        color: inherit

// label
.fieldset__label
  display: block
  padding: var(--input-padding-v) 0
  font-size: var(--label-fontsize)
  font-weight: normal
  line-height: var(--post-title-line-height)

// input
.fieldset__input
  font-family: inherit
  font-size: inherit
  font-weight: inherit
  line-height: inherit
  padding: var(--input-padding-v) var(--input-padding-h)
  border-style: solid
  border-color: var(--input-border-color)
  border-width: 0 0 1px 0
  color: var(--base-color)
  margin-bottom: 1rem
  background-image: linear-gradient(var(--input-border-color), var(--input-border-color))
  background-size: 0% var(--underline-effect-line-height)
  background-repeat: no-repeat
  background-position: bottom center
  will-change: background-size
  transition: border-color 0.3s, background-image 0.3s, background-size 0.3s

  &:hover
    --input-border-color: var(--accent-color)
    border-color: var(--input-border-color)
    background-image: linear-gradient(var(--input-border-color), var(--input-border-color))
    background-size: 100% var(--underline-effect-line-height)

  &:active,
  &:focus
    --input-border-color: var(--accent-color)
    border-color: var(--input-border-color)
    background-color: hsla(var(--accent-color-h), var(--accent-color-s), var(--accent-color-l), .1)
    background-image: linear-gradient(var(--input-border-color), var(--input-border-color))
    background-size: 100% var(--underline-effect-line-height)
    outline: none

  &.--error
    background-color: hsla(var(--error-color-h), var(--error-color-s), var(--error-color-l), .1)
    background-image: linear-gradient(var(--error-color), var(--error-color))
    background-size: 100% var(--underline-effect-line-height)

.fieldset__error
  color: var(--error-color)
  font-size: .8rem
  line-height: 2
  margin-bottom: calc(.8rem * 2 * -1)

// overrides
.fieldset
  .fieldset__input
    margin-bottom: 0
</style>
